import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import LanguageSelector from '../../../components/base/LanguageSelector';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    
    // Se não estiver na página inicial, navega primeiro para lá
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }
    
    // Se já estiver na página inicial, faz scroll suave
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-gradient-to-r from-yellow-300 via-orange-400 to-orange-500 shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <a href="/" className="cursor-pointer" aria-label="FARWAYS - Página Inicial">
              <img 
                src="https://static.readdy.ai/image/88ba7c39681cb796cee4e89aebadeff7/76dc25c0bcc578ed59ccf9df16a388c2.png" 
                alt="FARWAYS VIAGENS - Transfers Aeroporto Faro Algarve" 
                className="h-20 w-auto object-contain"
                width="200"
                height="80"
              />
            </a>
          </div>
          
          <nav className="hidden md:flex items-center space-x-8" aria-label="Navegação principal">
            <a 
              href="/#home" 
              onClick={(e) => handleNavClick(e, 'home')}
              className="text-gray-800 hover:text-white transition-colors cursor-pointer font-semibold"
              aria-label="Ir para Início"
            >
              {t('home')}
            </a>
            <a 
              href="/#frota" 
              onClick={(e) => handleNavClick(e, 'frota')}
              className="text-gray-800 hover:text-white transition-colors cursor-pointer font-semibold"
              aria-label="Ver nossa Frota"
            >
              {t('fleet')}
            </a>
            <a 
              href="/#servicos" 
              onClick={(e) => handleNavClick(e, 'servicos')}
              className="text-gray-800 hover:text-white transition-colors cursor-pointer font-semibold"
              aria-label="Ver Serviços"
            >
              {t('services')}
            </a>
            <a 
              href="/#sobre" 
              onClick={(e) => handleNavClick(e, 'sobre')}
              className="text-gray-800 hover:text-white transition-colors cursor-pointer font-semibold"
              aria-label="Sobre a FARWAYS"
            >
              {t('about')}
            </a>
            <a 
              href="/pricing" 
              className="text-gray-800 hover:text-white transition-colors cursor-pointer font-semibold"
              aria-label="Ver Preços"
            >
              {t('pricing')}
            </a>
            <a 
              href="/contactos" 
              className="text-gray-800 hover:text-white transition-colors cursor-pointer font-semibold"
              aria-label="Contactar-nos"
            >
              {t('contacts')}
            </a>
            <a href="/faq" className="text-gray-800 hover:text-white transition-colors cursor-pointer font-semibold">
              FAQ
            </a>
            <LanguageSelector />
          </nav>

          <div className="md:hidden flex items-center space-x-4">
            <LanguageSelector />
            <button
              className="p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label={isMenuOpen ? "Fechar menu" : "Abrir menu"}
              aria-expanded={isMenuOpen}
              aria-controls="mobile-menu"
            >
              <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-800`}></i>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div 
            id="mobile-menu" 
            className="md:hidden py-4 border-t border-orange-600"
            role="navigation"
            aria-label="Menu mobile"
          >
            <nav className="flex flex-col space-y-4">
              <a 
                href="/#home" 
                onClick={(e) => handleNavClick(e, 'home')}
                className="text-gray-800 hover:text-white transition-colors cursor-pointer font-semibold"
              >
                {t('home')}
              </a>
              <a 
                href="/#frota" 
                onClick={(e) => handleNavClick(e, 'frota')}
                className="text-gray-800 hover:text-white transition-colors cursor-pointer font-semibold"
              >
                {t('fleet')}
              </a>
              <a 
                href="/#servicos" 
                onClick={(e) => handleNavClick(e, 'servicos')}
                className="text-gray-800 hover:text-white transition-colors cursor-pointer font-semibold"
              >
                {t('services')}
              </a>
              <a 
                href="/#sobre" 
                onClick={(e) => handleNavClick(e, 'sobre')}
                className="text-gray-800 hover:text-white transition-colors cursor-pointer font-semibold"
              >
                {t('about')}
              </a>
              <a href="/pricing" className="text-gray-800 hover:text-white transition-colors cursor-pointer font-semibold">
                {t('pricing')}
              </a>
              <a href="/contactos" className="text-gray-800 hover:text-white transition-colors cursor-pointer font-semibold">
                {t('contacts')}
              </a>
              <a href="/faq" className="text-gray-800 hover:text-white transition-colors cursor-pointer font-semibold">
                FAQ
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
